/**
 * Mao AI Assistant Configuration
 *
 * Central configuration for the AI assistant persona.
 * The name can be overridden via environment variable for white-label support.
 */

/**
 * The assistant's display name.
 * Override with VITE_ASSISTANT_NAME environment variable.
 */
export const ASSISTANT_NAME: string =
  import.meta.env.VITE_ASSISTANT_NAME || 'Mao';

/**
 * Get the current assistant name.
 * Use this function instead of the constant for future extensibility
 * (e.g., tenant-specific overrides, runtime configuration).
 */
export function getAssistantName(): string {
  return ASSISTANT_NAME;
}

/**
 * Assistant visual configuration
 */
export const ASSISTANT_CONFIG = {
  /** Primary color for the assistant UI (Tailwind class) */
  primaryColor: 'lavender',
  /** Icon component name from lucide-react */
  icon: 'Sparkles',
  /** Default animation variant */
  defaultAnimation: 'pulse' as const,
} as const;
